import { render, staticRenderFns } from "./ReadOnlyCompany.vue?vue&type=template&id=5bf7d9d8&"
import script from "./ReadOnlyCompany.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports